import { Injectable } from '@angular/core';
import { DataCoreService} from '@dabnet-kamu/libs/ui';
import { TebEkonomikService } from '../ctl-teb-ekonomik.service';
@Injectable()
export class Service {

    constructor(private dataCoreService: DataCoreService, private service: TebEkonomikService) {}

    getData() {
        if(this.service.piHesapTuru === 1){
            const dataSource = this.dataCoreService.getOData('TebGelir');
            dataSource.select([
                'Kod',
                'Ad',
                'Donem',
                'EkoGelirKod',
            ]);


            const filterArr = [];
            if(this.service.period) filterArr.push(['Donem', '=', this.service.period]);
            filterArr.push(['EkoGelirKod.Length', '>=', 6]);
            dataSource.filter(filterArr)
            return dataSource;
        }else if(this.service.harcamaKodu === null && this.service.piHesapTuru === 2){
            const dataSource = this.dataCoreService.getOData('TebGider');
            dataSource.select([
                'Kod',
                'Ad',
                'Donem',
                'EkoGiderKod',
            ]);


            const filterArr = [];
            if(this.service.period) filterArr.push(['Donem', '=', this.service.period]);
            filterArr.push(['EkoGiderKod.Length', '>=', 6]);
            dataSource.filter(filterArr)
            return dataSource;
        }
        else return null;
    }
}
